// extracted by mini-css-extract-plugin
export default {"header":"Header_header__zvWL-","container":"Header_container__LwyMu","logo":"Header_logo__RmOVR","title":"Header_title__TE+ax"};